import React from 'react';
import { t } from '../i18n';

const colors = {
  bg: '#F7F5F0',
  surface: '#fff',
  border: '#E3E1D9',
  text: '#1F1E1B',
  textMuted: '#5F5E5A',
  primary: '#0F6E56',
};

function HubCard({ emoji, title, sub, href }) {
  return (
    <a
      href={href}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        background: colors.surface,
        border: `0.5px solid ${colors.border}`,
        borderRadius: 14,
        padding: '1rem',
        textDecoration: 'none',
        marginBottom: 10,
      }}
    >
      <div style={{ fontSize: 28 }}>{emoji}</div>
      <div>
        <p style={{ fontSize: 15, fontWeight: 600, color: colors.text, margin: 0 }}>{title}</p>
        <p style={{ fontSize: 12, color: colors.textMuted, margin: '2px 0 0' }}>{sub}</p>
      </div>
    </a>
  );
}

export default function ShoppingHub() {
  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '1.5rem', background: colors.bg, minHeight: '100vh', fontFamily: 'sans-serif' }}>
      <h1 style={{ fontSize: 22, margin: '0 0 4px' }}>🛍️ {t('sh_title')}</h1>
      <p style={{ fontSize: 13, color: colors.textMuted, margin: '0 0 1.5rem' }}>
        Buy from Pi merchants, or set up your own store.
      </p>

      <p style={{ fontSize: 12, fontWeight: 600, color: colors.textMuted, textTransform: 'uppercase', margin: '0 0 8px' }}>{t('sh_shop')}</p>
      <HubCard emoji="🛒" title={t('sh_marketplace')} sub="Browse and buy products from all merchants" href="/marketplace" />
        <HubCard emoji="🔧" title={t('sh_services')} sub="Hire a plumber, electrician & more near you" href="/services" />
      <HubCard emoji="📒" title={t('sh_dir')} sub="Search merchants by category and location" href="/directory" />
      <HubCard emoji="🗺️" title={t('sh_map')} sub="Find Pi-accepting shops near you" href="/merchants" />
      <HubCard emoji="📦" title={t('sh_track')} sub="Look up a delivery by tracking code" href="/marketplace" />

      <p style={{ fontSize: 12, fontWeight: 600, color: colors.textMuted, textTransform: 'uppercase', margin: '1.5rem 0 8px' }}>{t('sh_sell')}</p>
      <HubCard emoji="🏪" title={t('sh_become_m')} sub="Register your business and start selling" href="/merchant-register" />
        <HubCard emoji="🔧" title={t('sh_become_sp')} sub="List yourself as a plumber, electrician & more" href="/services/register" />
      <HubCard emoji="📊" title={t('sh_dash')} sub="Manage your products, orders, wallet, and inventory" href="/marketplace" />
      <HubCard emoji="💎" title={t('sh_plans')} sub="Compare Free / Starter / Pro / Unlimited tiers" href="/merchant-tiers" />
      <HubCard emoji="🧾" title={t('sh_subs')} sub="View or upgrade your current plan" href="/my-subscriptions" />
    </div>
  );
}
